namespace Ir.Components.General.RenameInput {

    interface IRenameInputViewModel {
        name: KnockoutObservable<string>;
        readOnly: KnockoutObservable<boolean>;
        fontColor: KnockoutObservable<string>;
        inputWidthCSS: KnockoutObservable<string>;
        editBackgroundColor: KnockoutComputed<string>;
        maxWidth: string;

        onInputKeyUp: Function;
        onInputChanged: Function;
        onInputBlur: Function;
    }
    export interface IRenameInputParams {
        name: KnockoutObservable<string>;
        readOnly?: KnockoutObservable<boolean> | boolean;
        fontColor: KnockoutObservable<string> | string;
        editBackgroundColor?: string;
        maxWidth?: string;
        save?: () => boolean;
    }

    export function getViewModel(this: IRenameInputViewModel, params: IRenameInputParams, componentInfo) {
        //To allow passing all params as an object 
        if ((params as any).config) {
            params = (params as any).config;
        }

        let self = this;

        this.name = params.name;
        this.readOnly = typeof params.readOnly === "boolean" ? ko.observable(params.readOnly) : params.readOnly;
        this.fontColor = typeof params.fontColor === "string" ? ko.observable(params.fontColor) : params.fontColor;
        this.inputWidthCSS = ko.observable();
        this.editBackgroundColor = ko.computed(function () {
            return !self.readOnly() && params.editBackgroundColor ? params.editBackgroundColor : "unset";
        });
        this.maxWidth = params.maxWidth ?? "300px";

        let updateWidth = function () {
            self.inputWidthCSS($("span", componentInfo.element).width() + 5 + "px");
        };

        this.onInputKeyUp = function (data, e) {
            //ESC
            if (e.keyCode === 27) {
                self.name(e.currentTarget.oldvalue);
                self.readOnly(true);
            }
            else if (e.keyCode === 13) {//ENTER
                self.readOnly(true);
            }

            updateWidth();
        };
        this.onInputChanged = function (data, e) {
            if (!self.name() && e.currentTarget.oldvalue) {
                self.name(e.currentTarget.oldvalue);
                updateWidth();
            }

            if (self.name() !== e.currentTarget.oldvalue) {
                if (params.save) {
                    let saved = params.save();
                    if (!saved) {
                        self.name(e.currentTarget.oldvalue);
                        updateWidth();
                    }
                }
            }
        };
        this.onInputBlur = function (e) {
            self.readOnly(true);
        };
        
        //https://knockoutjs.com/documentation/binding-lifecycle-events.html
        (ko as any).bindingEvent.subscribe(componentInfo.element, 'descendantsComplete', function (node) {
            // You can add custom post-processing logic here
            updateWidth();
        });
    }
}